import { editorOnlyTypes } from '@/features/backtest/schemas/compound'

/**
 * Node types that exist in the editor but must never reach the run engine.
 *
 * RetroStock deserializes every node in the payload by type, so a type it does
 * not know fails the whole run. The `universe` node is editor-only by design:
 * it names the sample a strategy runs against, which is the batch runner's
 * concern and is carried on the run itself, not something the per-ticker engine
 * evaluates.
 *
 * The strip lives in `buildEngineStrategyGraph`, which is the single seam every
 * engine payload passes through (preview, single run, CSV batch, debug run), so
 * one entry here covers all of them.
 *
 * The `report` node is editor-only too: it carries how a strategy is run (sizing
 * mode, cash, costs) and the Run button, none of which the engine evaluates.
 *
 * Declared on each schema (`compound.engine: 'editor-only'`, schemas/compound.ts).
 *
 * Design: docs/superpowers/specs/2026-08-31-backtest-strategy-workspace-design.md
 */
export function isEditorOnlyNodeType(type: string | undefined): boolean {
  return type !== undefined && editorOnlyTypes().has(type)
}
